/* Mia Mur Flowers — Global theme JS. No jQuery, no heavy libraries. */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initMegaMenu();
    initMobileNav();
    initAccordions();
    initCarousels();
    initCartDrawer();
    initQuickAdd();
    initVariantPickers();
    initAddToCartForms();
    initQuantitySelectors();
    initProductGallery();
    initFilterDrawer();
    initEmailPopup();
    initPredictiveSearch();
    initFulfillment();
  });

  /* ---------------- Desktop mega menu: hover + keyboard + Escape ---------------- */
  function initMegaMenu() {
    var items = document.querySelectorAll('[data-mega-menu-item]');
    items.forEach(function (item) {
      var link = item.querySelector('[data-mega-menu-trigger]');
      var panel = item.querySelector('.mega-menu-wrap');
      if (!link || !panel) return;

      link.setAttribute('aria-expanded', 'false');
      var panelId = panel.id || 'mega-' + Math.random().toString(36).slice(2, 8);
      panel.id = panelId;
      link.setAttribute('aria-controls', panelId);

      var closeTimer;
      function open() {
        clearTimeout(closeTimer);
        closeAllMegaMenus();
        item.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
      }
      function close() {
        item.classList.remove('is-open');
        link.setAttribute('aria-expanded', 'false');
      }
      function scheduleClose() {
        closeTimer = setTimeout(close, 150);
      }

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduleClose);

      link.addEventListener('focus', open);
      link.addEventListener('click', function (e) {
        // Top-level link still navigates; Enter/click on caret-only areas could toggle,
        // but keep this simple: focus opens on desktop already.
      });

      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', scheduleClose);

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          close();
          link.focus();
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllMegaMenus();
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mega-menu-item]')) closeAllMegaMenus();
    });
  }

  function closeAllMegaMenus() {
    document.querySelectorAll('[data-mega-menu-item].is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var link = item.querySelector('[data-mega-menu-trigger]');
      if (link) link.setAttribute('aria-expanded', 'false');
    });
  }

  /* ---------------- Mobile nav: multi-level drawer ---------------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    var overlay = document.querySelector('[data-mobile-drawer-overlay]');
    var closeBtn = document.querySelector('[data-mobile-drawer-close]');
    if (!toggle || !drawer) return;

    function open() {
      drawer.classList.add('is-open');
      overlay && overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      drawer.classList.remove('is-open');
      overlay && overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
      // Reset all sub-panels
      document.querySelectorAll('.mobile-nav__panel.is-open').forEach(function (p) {
        p.classList.remove('is-open');
      });
    }

    toggle.addEventListener('click', open);
    closeBtn && closeBtn.addEventListener('click', close);
    overlay && overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Drill-down navigation
    document.querySelectorAll('[data-mobile-nav-open-panel]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetId = btn.getAttribute('data-mobile-nav-open-panel');
        var panel = document.getElementById(targetId);
        if (panel) panel.classList.add('is-open');
      });
    });
    document.querySelectorAll('[data-mobile-nav-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('.mobile-nav__panel');
        if (panel) panel.classList.remove('is-open');
      });
    });
  }

  /* ---------------- Accordions (product info / FAQ) ---------------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      var item = trigger.closest('[data-accordion-item]');
      var panel = item ? item.querySelector('.accordion-item__panel, .faq-item__panel') : null;
      if (panel && !panel.id) panel.id = 'panel-' + Math.random().toString(36).slice(2, 8);
      if (panel) trigger.setAttribute('aria-controls', panel.id);
      trigger.setAttribute('aria-expanded', item && item.classList.contains('is-open') ? 'true' : 'false');

      trigger.addEventListener('click', function () {
        if (!item) return;
        var wasOpen = item.classList.contains('is-open');
        var singleGroup = item.closest('[data-accordion-single]');
        if (singleGroup) {
          singleGroup.querySelectorAll('[data-accordion-item].is-open').forEach(function (openItem) {
            if (openItem !== item) {
              openItem.classList.remove('is-open');
              var t = openItem.querySelector('[data-accordion-trigger]');
              if (t) t.setAttribute('aria-expanded', 'false');
            }
          });
        }
        item.classList.toggle('is-open', !wasOpen);
        trigger.setAttribute('aria-expanded', String(!wasOpen));
      });
    });
  }

  /* ---------------- Carousels ---------------- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]') || carousel;
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (!track) return;

      function scrollByAmount(dir) {
        var itemEl = track.querySelector('[data-carousel-item]');
        var itemWidth = itemEl ? itemEl.getBoundingClientRect().width + 24 : 300;
        track.scrollBy({ left: dir * itemWidth * 2, behavior: 'smooth' });
      }
      prev && prev.addEventListener('click', function () { scrollByAmount(-1); });
      next && next.addEventListener('click', function () { scrollByAmount(1); });
    });
  }

  /* ---------------- Cart Drawer ---------------- */
  function initCartDrawer() {
    var cartType = document.body.getAttribute('data-cart-type');

    // Always re-query from the live DOM: refreshCartDrawer() replaces the drawer
    // node (it lives inside #cart-drawer-root), so any cached reference goes stale.
    function getDrawer() { return document.querySelector('[data-cart-drawer]'); }
    function getOverlay() { return document.querySelector('[data-cart-drawer-overlay]'); }

    function open() {
      if (cartType === 'page') return;
      refreshCartDrawer().then(function () {
        var drawer = getDrawer(), overlay = getOverlay();
        if (drawer) drawer.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    }
    function close() {
      var drawer = getDrawer(), overlay = getOverlay();
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // Delegated listeners bound once on document — survive drawer DOM replacement
    // and never accumulate on refresh.
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-open]')) {
        if (cartType === 'page') return; // let the link navigate to /cart
        e.preventDefault(); open(); return;
      }
      if (e.target.closest('[data-cart-drawer-close]')) { e.preventDefault(); close(); return; }
      if (e.target.closest('[data-cart-drawer-overlay]')) { close(); }
    });
    document.addEventListener('keydown', function (e) {
      var drawer = getDrawer();
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close();
    });

    window.MiaMurCart = { open: open, close: close, refresh: refreshCartDrawer };
  }

  function refreshCartDrawer() {
    var root = document.getElementById('cart-drawer-root');
    if (!root) return Promise.resolve();
    return fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContent = doc.querySelector('[data-cart-drawer-section]');
        if (newContent) {
          root.innerHTML = newContent.outerHTML;
          initQuantitySelectors();
          bindCartLineEvents();
        }
      })
      .catch(function () {});
  }

  function bindCartLineEvents() {
    document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        updateCartLine(btn.getAttribute('data-cart-remove'), 0);
      });
    });
    document.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        updateCartLine(input.getAttribute('data-cart-qty-input'), parseInt(input.value, 10) || 0);
      });
    });
  }

  function updateCartLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () { return refreshCartDrawer(); })
      .then(function () { updateCartCount(); });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  bindCartLineEvents();

  /* ---------------- Add to cart forms (AJAX) ---------------- */
  function initAddToCartForms() {
    document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        var submitBtn = form.querySelector('[data-add-to-cart-btn]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.dataset.originalText = submitBtn.textContent;
          submitBtn.textContent = 'Adding...';
        }
        fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function () { updateCartCount(); })
          .then(function () { if (window.MiaMurCart && document.body.getAttribute('data-cart-type') !== 'page') window.MiaMurCart.open(); else window.location.href = '/cart'; })
          .catch(function () {})
          .finally(function () {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
          });
      });
    });
  }

  /* ---------------- Quick add (collection cards) ---------------- */
  function initQuickAdd() {
    document.querySelectorAll('[data-quick-add-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function () { updateCartCount(); })
          .then(function () { if (window.MiaMurCart) window.MiaMurCart.open(); })
          .catch(function () {});
      });
    });
  }

  /* ---------------- Selling plan (subscription) radios ----------------
     One-time purchase radio has an empty value; when selected, the field
     must be omitted entirely from the POST body (not sent as empty string),
     so the native /cart/add.js call treats it as a normal one-time sale. */
  document.querySelectorAll('[data-selling-plan-radio]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      var groupRadios = document.querySelectorAll('[data-selling-plan-radio]');
      groupRadios.forEach(function (r) {
        r.disabled = (r.value === '' && r.checked);
      });
    });
  });

  /* ---------------- Variant pickers ---------------- */
  function initVariantPickers() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var variants = [];
      try { variants = JSON.parse(picker.getAttribute('data-variants')); } catch (err) { variants = []; }

      var selects = picker.querySelectorAll('[data-option-index]');
      var idInput = picker.querySelector('[data-variant-id-input]');
      var priceEl = document.querySelector('[data-product-price="' + picker.getAttribute('data-product-id') + '"]');
      var addBtn = document.querySelector('[data-add-to-cart-btn][data-product-id="' + picker.getAttribute('data-product-id') + '"]');

      function getSelectedOptions() {
        var opts = [];
        selects.forEach(function (group) {
          var active = group.querySelector('.is-selected');
          opts.push(active ? active.getAttribute('data-value') : null);
        });
        return opts;
      }
      function findVariant() {
        var opts = getSelectedOptions();
        return variants.find(function (v) { return v.options.every(function (val, i) { return val === opts[i]; }); });
      }
      function updateUI() {
        var variant = findVariant();
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? (addBtn.getAttribute('data-label-available') || 'Add to Cart') : 'Sold Out';
        }
        if (priceEl && variant.price) priceEl.textContent = formatMoney(variant.price);
      }

      picker.querySelectorAll('[data-value]').forEach(function (option) {
        option.addEventListener('click', function () {
          var group = option.closest('[data-option-index]');
          group.querySelectorAll('[data-value]').forEach(function (o) { o.classList.remove('is-selected'); });
          option.classList.add('is-selected');
          updateUI();
        });
      });
      updateUI();
    });
  }

  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }

  /* ---------------- Quantity selectors ---------------- */
  function initQuantitySelectors() {
    document.querySelectorAll('[data-quantity-selector]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var minus = wrap.querySelector('[data-quantity-minus]');
      var plus = wrap.querySelector('[data-quantity-plus]');
      if (!input) return;
      minus && minus.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.dispatchEvent(new Event('change'));
      });
      plus && plus.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
        input.dispatchEvent(new Event('change'));
      });
    });
  }

  /* ---------------- Product gallery ---------------- */
  function initProductGallery() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var mainImg = gallery.querySelector('[data-gallery-main-image]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var newSrc = thumb.getAttribute('data-full-src');
          if (mainImg && newSrc) mainImg.src = newSrc;
          thumbs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-current', 'false'); });
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ---------------- Predictive search (Shopify native endpoint) ---------------- */
  function initPredictiveSearch() {
    var openers = document.querySelectorAll('[data-predictive-search-open]');
    var panel = document.querySelector('[data-predictive-search]');
    var overlay = document.querySelector('[data-predictive-search-overlay]');
    var closeBtn = document.querySelector('[data-predictive-search-close]');
    var input = document.querySelector('[data-predictive-search-input]');
    var resultsEl = document.querySelector('[data-predictive-search-results]');
    if (!panel || !input) return;

    function open() {
      panel.classList.add('is-open');
      overlay && overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { input.focus(); }, 100);
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
    }
    function close() {
      panel.classList.remove('is-open');
      overlay && overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
    }

    openers.forEach(function (btn) { btn.addEventListener('click', open); });
    closeBtn && closeBtn.addEventListener('click', close);
    overlay && overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
    });

    var debounceTimer;
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var query = input.value.trim();
      if (query.length < 2) {
        if (resultsEl) resultsEl.innerHTML = '';
        return;
      }
      debounceTimer = setTimeout(function () { fetchResults(query); }, 250);
    });

    function fetchResults(query) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,vendor')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          renderResults(data.resources ? data.resources.results.products : []);
        })
        .catch(function () {});
    }

    function renderResults(products) {
      if (!resultsEl) return;
      if (!products || products.length === 0) {
        resultsEl.innerHTML = '<p style="font-size:13px;opacity:.6;padding:12px 0;">No products found.</p>';
        return;
      }
      var html = products.map(function (p) {
        var img = p.featured_image ? p.featured_image.url : '';
        return (
          '<a href="' + p.url + '" style="display:flex;gap:14px;align-items:center;padding:10px 4px;border-bottom:1px solid var(--color-line);">' +
          (img ? '<img src="' + img + '" alt="" width="50" height="50" style="width:50px;height:50px;object-fit:cover;background:var(--color-stone);">' : '') +
          '<span style="font-size:13.5px;">' + p.title + '</span>' +
          '</a>'
        );
      }).join('');
      resultsEl.innerHTML = html;
    }
  }

  /* ---------------- Mobile filter drawer ---------------- */
  function initFilterDrawer() {
    var drawer = document.querySelector('[data-filter-drawer]');
    var overlay = document.querySelector('[data-filter-drawer-overlay]');
    var openers = document.querySelectorAll('[data-filter-drawer-open]');
    var closers = document.querySelectorAll('[data-filter-drawer-close]');
    if (!drawer) return;

    function open() { drawer.classList.add('is-open'); overlay && overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); overlay && overlay.classList.remove('is-open'); document.body.style.overflow = ''; }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    overlay && overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------------- Email popup ---------------- */
  function initEmailPopup() {
    var popup = document.querySelector('[data-email-popup]');
    var overlay = document.querySelector('[data-email-popup-overlay]');
    var closeBtn = document.querySelector('[data-email-popup-close]');
    if (!popup) return;

    var delaySeconds = parseInt(popup.getAttribute('data-delay'), 10) || 8;
    var SUB = 'miamur_popup_subscribed';   // set forever once the visitor subscribes
    var SNOOZE = 'miamur_popup_snooze';    // ms timestamp until which we won't show
    var DISMISS = 'miamur_popup_dismisses';// how many times the visitor has closed it
    var SHORT_MS = 60 * 1000;              // one gentle re-show after ~1 min
    var LONG_MS = 3 * 24 * 60 * 60 * 1000; // then leave them alone for 3 days
    var reopenTimer = null;

    function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

    function close() {
      popup.classList.remove('is-open');
      overlay && overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    function open() {
      if (get(SUB)) return;
      popup.classList.add('is-open');
      overlay && overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function dismiss() {
      if (reopenTimer) { clearTimeout(reopenTimer); reopenTimer = null; }
      close();
      var n = (parseInt(get(DISMISS), 10) || 0) + 1;
      set(DISMISS, String(n));
      if (n >= 2) {
        set(SNOOZE, String(Date.now() + LONG_MS));
      } else {
        set(SNOOZE, String(Date.now() + SHORT_MS));
        reopenTimer = setTimeout(open, SHORT_MS); // nudge once more after a minute
      }
    }

    function markSubscribed() {
      set(SUB, '1');
      // Prime the WELCOME15 discount so it auto-applies at checkout (no manual code entry)
      try { fetch('/discount/WELCOME15', { credentials: 'same-origin' }); } catch (e) {}
    }

    var params = new URLSearchParams(window.location.search);
    var isSuccess = params.get('customer_posted') === 'true' && popup.hasAttribute('data-show-success-on-load');

    if (isSuccess) {
      open();
      markSubscribed();
    } else {
      var snooze = parseInt(get(SNOOZE), 10) || 0;
      if (!get(SUB) && Date.now() > snooze) {
        setTimeout(open, delaySeconds * 1000);
      }
    }

    closeBtn && closeBtn.addEventListener('click', dismiss);
    overlay && overlay.addEventListener('click', dismiss);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) dismiss();
    });
  }

  /* ---------------- Fulfillment: Local Delivery (ZIP quote) / Aventura Pickup ---------------- */
  function initFulfillment() {
    var root = document.querySelector('[data-fulfillment]');
    if (!root) return;
    var tabs = root.querySelectorAll('[data-fulfill-tab]');
    var panels = root.querySelectorAll('[data-fulfill-panel]');
    var zipInput = root.querySelector('[data-zip-input]');
    var checkBtn = root.querySelector('[data-zip-check]');
    var resultEl = root.querySelector('[data-zip-result]');
    var fulfillProp = root.querySelector('[data-fulfill-prop]');
    var zipProp = root.querySelector('[data-zip-prop]');
    var feeProp = root.querySelector('[data-fee-prop]');
    var dateProp = root.querySelector('[data-date-prop]');
    var slotProp = root.querySelector('[data-slot-prop]');
    var schedLabel = root.querySelector('[data-schedule-label]');
    var schedErr = root.querySelector('[data-schedule-err]');
    var activeMethod = 'delivery';

    function zips(attr) { return (root.getAttribute(attr) || '').split(/[^0-9]+/).filter(Boolean); }
    var free = zips('data-zips-free'), t1 = zips('data-zips-t1'), t2 = zips('data-zips-t2');
    var fee1 = parseFloat(root.getAttribute('data-fee-t1')) || 29;
    var fee2 = parseFloat(root.getAttribute('data-fee-t2')) || 44;

    function setMethod(method) {
      activeMethod = method;
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-fulfill-tab') === method;
        t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on);
      });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-fulfill-panel') === method); });
      if (method === 'pickup') {
        fulfillProp.value = 'Aventura Pickup';
        zipProp.disabled = true;
        feeProp.value = 'Free — pickup'; feeProp.disabled = false;
        if (schedLabel) schedLabel.textContent = 'Choose a pickup date';
      } else {
        fulfillProp.value = 'Local delivery';
        if (zipProp.value) { zipProp.disabled = false; feeProp.disabled = false; }
        if (schedLabel) schedLabel.textContent = 'Choose a delivery date';
      }
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { setMethod(t.getAttribute('data-fulfill-tab')); }); });

    function quote() {
      var zip = (zipInput.value || '').replace(/[^0-9]/g, '').slice(0, 5);
      if (zip.length < 5) {
        resultEl.textContent = 'Please enter a 5-digit ZIP code.';
        resultEl.className = 'fulfillment__result fulfillment__result--err';
        zipProp.disabled = true; feeProp.disabled = true; return;
      }
      // Tiered by distance: free within ~10 mi, $29 ~15 mi, $44 ~20 mi (matches the
      // native Local Delivery ZIP zones set in Shopify Admin → Shipping → Local delivery).
      var fee = null, label = '';
      if (free.indexOf(zip) > -1) { fee = 0; label = 'Free local delivery to ' + zip + '. 🎉'; }
      else if (t1.indexOf(zip) > -1) { fee = fee1; label = 'Local delivery to ' + zip + ': $' + fee1 + '.'; }
      else if (t2.indexOf(zip) > -1) { fee = fee2; label = 'Local delivery to ' + zip + ': $' + fee2 + '.'; }
      if (fee === null) {
        resultEl.textContent = zip + ' is outside our local delivery area. Please choose Aventura Pickup, or contact us for a custom quote.';
        resultEl.className = 'fulfillment__result fulfillment__result--err';
        zipProp.disabled = true; feeProp.disabled = true; return;
      }
      resultEl.textContent = label;
      resultEl.className = 'fulfillment__result' + (fee === 0 ? ' fulfillment__result--free' : '');
      fulfillProp.value = 'Local delivery';
      zipProp.value = zip; zipProp.disabled = false;
      feeProp.value = fee === 0 ? 'Free' : ('$' + fee); feeProp.disabled = false;
    }
    checkBtn && checkBtn.addEventListener('click', quote);
    zipInput && zipInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); quote(); } });

    /* ---- Date + time-window scheduler (shared by delivery & pickup) ---- */
    var calGrid = root.querySelector('[data-cal-grid]');
    if (calGrid) {
      var calTitle = root.querySelector('[data-cal-title]');
      var prevBtn = root.querySelector('[data-cal-prev]');
      var nextBtn = root.querySelector('[data-cal-next]');
      var slotsWrap = root.querySelector('[data-slots]');
      var slotsList = root.querySelector('[data-slots-list]');
      var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var WK = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      // Same-day (before 3pm cutoff) → 1 evening window; next-day → 3 windows;
      // 2+ days ahead → 4 windows (adds the early 8am slot).
      var SLOTS_SAME = ['4:00 PM – 9:00 PM'];
      var SLOTS_NEXT = ['10:00 AM – 3:00 PM', '2:00 PM – 6:00 PM', '4:00 PM – 9:00 PM'];
      var SLOTS_LATER = ['8:00 AM – 1:00 PM', '10:00 AM – 3:00 PM', '2:00 PM – 6:00 PM', '4:00 PM – 9:00 PM'];
      var CUTOFF_HOUR = 15; // same-day orders accepted until 3:00 PM (store time)

      // Determine "today" and the current hour in the STORE timezone (Miami / ET),
      // so the 3pm same-day cutoff is correct regardless of the visitor's timezone.
      function storeNow() {
        try {
          var parts = {};
          new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false })
            .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
          var h = parseInt(parts.hour, 10); if (h >= 24) h = 0;
          return { y: parseInt(parts.year, 10), m: parseInt(parts.month, 10), d: parseInt(parts.day, 10), h: h };
        } catch (err) {
          var n = new Date();
          return { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate(), h: n.getHours() };
        }
      }
      var sn = storeNow();
      var todayMid = new Date(sn.y, sn.m - 1, sn.d);
      var sameDayOk = sn.h < CUTOFF_HOUR; // before 3pm → today can be picked
      var minMid = sameDayOk ? todayMid : new Date(todayMid.getTime() + 86400000);
      var viewY = todayMid.getFullYear(), viewM = todayMid.getMonth();
      var selected = null;

      function daysAhead(d) { return Math.round((d.getTime() - todayMid.getTime()) / 86400000); }
      function slotsFor(d) {
        var n = daysAhead(d);
        if (n <= 0) return SLOTS_SAME;   // today (only reachable before 3pm cutoff)
        if (n === 1) return SLOTS_NEXT;  // tomorrow → 3 windows
        return SLOTS_LATER;              // 2+ days → 4 windows
      }
      function sameDay(a, b) { return a && b && a.getTime() === b.getTime(); }

      function clearSlots() {
        slotsWrap.hidden = true; slotsList.innerHTML = '';
        slotProp.value = ''; slotProp.disabled = true;
      }
      function renderSlots() {
        slotsList.innerHTML = '';
        slotProp.value = ''; slotProp.disabled = true;
        var arr = slotsFor(selected);
        arr.forEach(function (label) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'slot-pill'; b.textContent = label;
          b.addEventListener('click', function () {
            slotsList.querySelectorAll('.slot-pill').forEach(function (p) { p.classList.remove('is-selected'); });
            b.classList.add('is-selected');
            slotProp.value = label; slotProp.disabled = false;
            if (schedErr) schedErr.hidden = true;
          });
          slotsList.appendChild(b);
        });
        slotsWrap.hidden = false;
      }
      function pickDate(d) {
        selected = d;
        dateProp.value = WK[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
        dateProp.disabled = false;
        renderSlots();
        renderGrid();
        if (schedErr) schedErr.hidden = true;
      }
      function renderGrid() {
        calTitle.textContent = MONTHS[viewM] + ' ' + viewY;
        calGrid.innerHTML = '';
        var startDow = new Date(viewY, viewM, 1).getDay();
        var days = new Date(viewY, viewM + 1, 0).getDate();
        for (var i = 0; i < startDow; i++) {
          var e = document.createElement('span'); e.className = 'cal__day cal__day--empty'; calGrid.appendChild(e);
        }
        for (var day = 1; day <= days; day++) {
          var dMid = new Date(viewY, viewM, day);
          var btn = document.createElement('button');
          btn.type = 'button'; btn.className = 'cal__day'; btn.textContent = day;
          if (dMid.getTime() < minMid.getTime()) { btn.disabled = true; }
          else {
            if (sameDay(dMid, selected)) btn.classList.add('is-selected');
            (function (dd) { btn.addEventListener('click', function () { pickDate(dd); }); })(dMid);
          }
          calGrid.appendChild(btn);
        }
        prevBtn.disabled = (viewY === todayMid.getFullYear() && viewM === todayMid.getMonth());
      }
      prevBtn.addEventListener('click', function () { if (prevBtn.disabled) return; viewM--; if (viewM < 0) { viewM = 11; viewY--; } renderGrid(); });
      nextBtn.addEventListener('click', function () { viewM++; if (viewM > 11) { viewM = 0; viewY++; } renderGrid(); });
      clearSlots();
      renderGrid();

      // Require date + time window (and a valid ZIP quote for delivery) before add-to-cart
      var pForm = root.closest('form');
      if (pForm) {
        pForm.addEventListener('submit', function (e) {
          var missing = [];
          if (dateProp.disabled) missing.push('a date');
          if (slotProp.disabled) missing.push('a time window');
          if (activeMethod === 'delivery' && zipProp.disabled) missing.push('a delivery ZIP');
          if (missing.length) {
            e.preventDefault(); e.stopImmediatePropagation();
            if (schedErr) { schedErr.textContent = 'Please select ' + missing.join(' and ') + ' before adding to cart.'; schedErr.hidden = false; }
            root.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, true);
      }
    }

    setMethod('delivery');
  }
})();
